<template>
    <div class="menu-catalogo">
        <div>
            <v-layout row>
                <v-list v-for="item in catalogoFinal" :key="'vList_' + item.catalogoCod">
                    <v-list-group :key="'vListGroup_' + item.catalogoCod" no-action>
                        <template v-slot:activator>
                            <v-list-tile :key="'vListTile_' + item.catalogoCod">
                                <v-list-tile-content :key="'vListTileContent_' + item.catalogoCod">
                                    <v-list-tile-title>{{ item.catalogoNome }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                        <template>
                            <MenuCatalogo :node="item.subCatalogo" />
                        </template>
                    </v-list-group>
                </v-list>
            </v-layout>
        </div>
        <div class="div-limpar-filtro">
            <v-btn elevation="1" small @click="limparFiltro()">Remover seleção</v-btn>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Constantes from '../utils/constantes';
import MenuCatalogo from '../components/MenuCatalogo.vue';

export default {
    components: {
        MenuCatalogo
    },
    data() {
        return {
            categorias: [],
            catalogoFinal: [],
            selectedItem: null,
        };
    },
    created() {
        this.carregarCategorias();
    },
    methods: {
        toggleSubMenu(item) {
            if (item.hasFilho) {
                this.selectedItem = this.selectedItem === item ? null : item;
            }
        },
        carregarCategorias() {
            const url = `${Constantes.URL_SERVIDOR}/catalogo/menu?empIntCod=${this.$route.params.id}`;

            axios.get(url)
                .then(response => {
                    this.categorias = response.data;

                    const catalogoCodSet = new Set();
                    const distinctData = this.categorias.filter(item => {
                        if (!catalogoCodSet.has(item.catalogoCod)) {
                            catalogoCodSet.add(item.catalogoCod);
                            return true;
                        }
                        return false;
                    });

                    const criarEstruturaRecursiva = (catalogoCodPai) => {
                        const subCatalogo = distinctData
                            .filter(item => item.catalogoCodPai === catalogoCodPai)
                            .map(item => {
                                const subItems = criarEstruturaRecursiva(item.catalogoCod);
                                return {
                                    catalogoCod: item.catalogoCod,
                                    catalogoNome: item.catalogoNome,
                                    catalogoCodPai: item.catalogoCodPai,
                                    codigoFabricante: item.codigoFabricante,
                                    hasFilho: item.hasFilho,
                                    subCatalogo: subItems,
                                };
                            });
                        return subCatalogo;
                    };

                    this.catalogoFinal = distinctData
                        .filter(item => item.catalogoCodPai === 0)
                        .map(item => {
                            const subItems = criarEstruturaRecursiva(item.catalogoCod);
                            return {
                                catalogoCod: item.catalogoCod,
                                catalogoNome: item.catalogoNome,
                                catalogoCodPai: item.catalogoCodPai,
                                codigoFabricante: item.codigoFabricante,
                                hasFilho: item.hasFilho,
                                subCatalogo: subItems,
                            };
                        });

                    console.log("this.catalogoFinal -> ", this.catalogoFinal);
                })
                .catch(error => {
                    console.error('Erro ao carregar categorias:', error);
                });
        },
        limparFiltro(){
            this.$store
                .dispatch("anuncio/filtrarCatalogos", { codFabricante: [], codEmpresa: this.$route.params.id })
                .then(() => {
                    this.hideLoading();
                })
                .catch(() => {
                    this.hideLoading();
                });
        }
    },
};
</script> 
  
<style>
.menu-catalogo {
    display: flex;
    justify-content: space-between;
    /* Distribui espaço entre catalogo1 e catalogo2 */
    align-items: center;
    /* Centraliza verticalmente */
    margin: 15px;
    width: 98%;
    background-color: #fff;
    font-size: small;
}

.subitem-menu {
    display: flex;
    justify-content: flex-start;
    margin-left: 30px;
}

.subitem-suspenso-menu {
    display: flex;
    justify-content: flex-start;
    margin-left: 15px;
}

.div-limpar-filtro {
    margin-right: 10px;
}
</style>